const form = {
  formId: "new-project-form",
  formField: {
    name: {
      name: "name",
      label: "اسم المشروع",
      type: "text",
      errorMsg: "اسم المشروع مطلوب.",
    },
    description: {
      name: "description",
      label: "الوصف",
      type: "text",
      errorMsg: "الوصف مطلوب.",
    },
    clientId: {
      name: "clientId",
      label: " العميل",
      type: "string",
      errorMsg: "رقم العميل مطلوب.",
    },
    budget: {
      name: "budget",
      label: "الميزانية",
      type: "number",
      errorMsg: "الميزانية مطلوبة.",
    },
    actualExpenditure: {
      name: "actualExpenditure",
      label: "المصروفات الفعلية",
      type: "number",
      errorMsg: "المصروفات الفعلية مطلوبة.",
    },
    startedDate: {
      name: "startedDate",
      label: "تاريخ البدء",
      type: "date",
      errorMsg: "تاريخ البدء مطلوب.",
    },
    endedDate: {
      name: "endedDate",
      label: "تاريخ الانتهاء",
      type: "date",
      errorMsg: "تاريخ الانتهاء مطلوب.",
    },
    budgetStatus: {
      name: "budgetStatus",
      label: "حالة الميزانية",
      type: "select",
      errorMsg: "حالة الميزانية مطلوبة.",
      options: [
        // أضف قائمة الخيارات هنا حسب المتطلبات
      ],
    },
    projectStatus: {
      name: "projectStatus",
      label: "حالة المشروع",
      type: "select",
      errorMsg: "حالة المشروع مطلوبة.",
      options: [
        // أضف قائمة الخيارات هنا حسب المتطلبات
      ],
    },
    categoryId: {
      name: "categoryId",
      label: " الفئة",
      type: "text",
      errorMsg: "رقم الفئة مطلوب.",
    },
    progress: {
      name: "progress",
      label: "نسبة التقدم",
      type: "number",
      errorMsg: "قيمة التقدم (0-100) مطلوبة.",
    },
    changeRequestCount: {
      name: "changeRequestCount",
      label: "عدد طلبات التغيير",
      type: "number",
      errorMsg: "عدد طلبات التغيير مطلوب.",
    },
    file: {
      name: "file",
      label: "تحميل صورة المشروع",
      type: "file",
      errorMsg: "تحميل صورة المشروع مطلوب.",
    },
    companyId: {
      name: "companyId",
      label: " الشركة",
      type: "text",
      errorMsg: "رقم الشركة مطلوب.",
    },
  },
};

export default form;
